<template>
  <div class="modal is-active modal-instructions" v-if="show">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="section container content has-text-centered">
        <h2 class="title">{{content.title}}</h2>

        <div v-if="showReasonForm" class="section">
          <p>Thank you for visiting leavemyunion.com – we hope you found the information you need.</p>

          <div v-if="wasReasonGiven">
            <p>Thank you!</p>
          </div>
          <div v-else>
            <p>{{content.reason.title}}</p>
            <div class="columns is-centered">
              <div class="column column-flex has-text-centered" v-for="item in content.reason.options" v-bind:key="item.value" v-on:click="selectReason(item)">
                <div class="notification is-primary">
                  <p>{{item.label}}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div v-else class="section">
          <div class="select" v-if="content.enabled.length > 1">
            <select v-model='selectedUnion' v-on:change="selectUnion">
              <option value="">{{content.cta.select}}</option>
              <option v-for="item in content.enabled" v-bind:key="item" v-bind:value="item">{{content.instructions[item].title}}</option>
            </select>
          </div>
          <div v-for="item in content.enabled" v-bind:key="item" v-show="item === selectedUnion" class="section">
            <div class="intro" v-html="content.instructions[item].intro"></div>
            <div class="box" v-for="(step, sindex) in content.instructions[item].steps" v-bind:key="sindex">
              <div class="media">
                <div class="media-left"><strong>{{step.title}}</strong></div>
                <div class="media-content">
                  <p v-if="step.path">
                    <a v-on:click='download(step)'>
                      <i class="i-push fas fa-external-link-square-alt" v-if="step.external"></i>
                      <i class="i-push fas fa-arrow-circle-down" v-else></i>
                      {{step.cta}}
                    </a>
                  </p>
                  <p v-else><strong>{{step.cta}}</strong></p>
                  <p class="help" v-html="step.help"></p>
                </div>
              </div>
            </div>
            <div v-if="content.instructions[item].tips" class="tips has-text-left">
              <strong>Additional tips</strong>
              <ul>
                <li v-for="(tip, index) in content.instructions[item].tips" v-bind:key="index" v-html="tip.label"></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="notification is-dark">
            <p v-html="content.cta.share"></p>
          </div>
        </div>

      </div>
      <footer class="footer">
        <div class="content has-text-left">
          <p><strong>{{content.footer.title}}</strong></p>
          <p v-html="content.footer.subtitle"></p>
          <p class="legal" v-html="content.footer.legal"></p>
        </div>
      </footer>
    </div>
    <button class="modal-close is-large" aria-label="close" v-on:click="$emit('close')"></button>
  </div>
</template>

<script>
let gtag; // mock global
let fbq;  // mock global

export default {
  name: 'InstructionDialog',
  props: {
    show: Boolean,
    content: Object
  },
  data: function() {
    return {
      selectedUnion:    '',
      showReasonForm:   false,
      wasReasonGiven:   false,
    }
  },
  mounted: function() {
    this.selectedUnion = window.location.hash.toLowerCase().replace('#', '');
  },
  updated: function() {
    this.selectedUnion = window.location.hash.toLowerCase().replace('#', '');
  },
  methods: {

    selectUnion: function() {
      if (this.content.instructions[this.selectedUnion]) {
        window.location.hash = this.selectedUnion;
      } else {
        window.location.hash = '';
      }
    },

    selectReason: function(reason) {
      this.wasReasonGiven = true;

      window.gtag('event', 'form', {
        'event_category': 'reason',
        'event_action':   'answer',
        'event_label':    reason.value
      });

      window.fbq('track', 'LeaveReason', {
        'value':   reason.value,
      });

      const _this = this;
      setTimeout(function(){
        _this.showReasonForm = false;
        _this.wasReasonGiven = false;
      }, 10000);
    },

    download: function(step) {
      window.open(step['path'], '_blank');

      window.gtag('event', 'form', {
        'event_category': step['a'],
        'event_label':    step['l']
      });

      window.fbq('track', 'Lead', {
        'content_name':     step['a'],
        'content_category': step['l']
      });

      if (step.showReasonForm) {
        this.showReasonForm = true;
      }
    },

    stepIcon: function(step) {
      if (step.link) {
        return 'fas fa-arrow-circle-down';
      } else {
        return 'fas fa-arrow-circle-down';
      }
    },

    openStoryBox: function() {
      if (!this.wasReasonGiven) {
        this.forceOpenReasonBox();
      }
    },

    forceOpenReasonBox: function() {
      this.showReasonForm = true;
    },

    closeReasonBox: function() {
      this.showReasonForm = false;
    }
  }
}
</script>

<style lang="scss">
.modal-instructions {
  &.modal.is-active {
    align-items: unset;
  }
  .modal-background {
    background-color: #fff;
  }
  .modal-close::after,
  .modal-close::before {
    background-color: #3b3b3b;
  }
  .modal-close:hover {
    &::after, &::before {
      background-color: #fff;
    }
  }
  .modal-content {
    width: 100%;
    max-height: unset;
  }
  .notification.is-dark {
    background-color: #0F1929;
    color: white;
    a {
      color: white !important;
      text-decoration: none;
    }
  }
  hr {
    background-color: #ececec66;
  }
  .column-flex {
    .notification {
      height: 100%;
      align-items: center;
      display: flex;
      cursor: pointer;
      &.is-primary {
        background-color: #677c84;
        &:hover {
          background-color: #a56969;
        }
      }
      p {
        width: 100%;
      }
    }
  }
  .i-push {
    margin-right: 5px;
  }
}
</style>
